import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

// ✅ 只引入必要的圖標，避免引入整個 FiIcons 並使用索引
const SafeIcon = React.memo(({ icon, className = '', ...props }) => {
  if (!icon) {
    return <FiAlertTriangle className={`text-red-500 ${className}`} {...props} />;
  }
  
  const Icon = icon;
  return <Icon className={className} {...props} />;
});

SafeIcon.displayName = 'SafeIcon';
export default SafeIcon;